<div class="modal-header border-0 pb-0">
  <div class="data-item d-flex align-items-center gap-3">
    <div class="data-icon bg-primary bg-opacity-10">
      <i class="fas fa-calendar-week text-primary"></i>
    </div>
    <h5 class="modal-title mb-0">
      {{ draft?.id ? ('lumPeriodEditTitleSimple' | translate) : ('lumPeriodCreateTitle' | translate) }}
    </h5>
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'close' | translate" (click)="cancel()"></button>
</div>

<div class="modal-body pt-3">
  <div class="row g-3">
    <div class="col-12 col-xl-2">
      <div class="d-flex flex-column gap-3">
        <div class="border rounded-3 p-3 bg-white shadow-sm">
          <label class="form-label small mb-1" for="lumPeriodName">
            <i class="fas fa-tag text-primary me-1"></i>{{ 'name' | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            id="lumPeriodName"
            name="lumPeriodName"
            [(ngModel)]="draft.name"
            [placeholder]="'lumPeriodNamePlaceholder' | translate">
          <div class="d-flex align-items-center gap-2 mt-3">
            <label class="switch mb-0">
              <input type="checkbox" id="lumPeriodEnabled" name="lumPeriodEnabled" [(ngModel)]="draft.enabled">
              <span class="slider round"></span>
            </label>
            <label class="mb-0" for="lumPeriodEnabled">{{ 'lumPeriodActive' | translate }}</label>
          </div>
        </div>

        <div class="border rounded-3 p-3 bg-white shadow-sm">
          <label class="form-label small mb-1">
            <i class="fas fa-calendar-alt text-primary me-1"></i>{{ 'lumPeriodFrom' | translate }} / {{ 'lumPeriodTo' | translate }}
          </label>
          <div class="lum-period-range-summary rounded-3 px-3 py-2 small d-flex align-items-center gap-2 mb-0"
            [ngStyle]="periodColorStyles">
            <span>{{ getrange() }}</span>
          </div>
        </div>

        <!-- <div class="border rounded-3 p-3 bg-white shadow-sm">
          <label class="form-label small mb-1">
            <i class="fas fa-clock text-primary me-1"></i>{{ 'lumPeriodSchedule' | translate }}
          </label>

          <div class="d-flex flex-column gap-2">
            <div>
              <input
                class="btn-check"
                type="radio"
                name="lumPeriodScheduleMode"
                id="lumPeriodFullDays"
                [value]="'fullDays'"
                [(ngModel)]="draft.scheduleMode"
                (ngModelChange)="onScheduleModeChange($event)">
              <label class="btn btn-outline-primary w-100 py-2 rounded-3" for="lumPeriodFullDays">
                <i class="fas fa-calendar-day me-2"></i>
                <span class="">{{ 'lumPeriodFullDays' | translate }}</span>
              </label>
            </div>
            <div>
              <input
                class="btn-check"
                type="radio"
                name="lumPeriodScheduleMode"
                id="lumPeriodWithTimes"
                [value]="'timed'"
                [(ngModel)]="draft.scheduleMode"
                (ngModelChange)="onScheduleModeChange($event)">
              <label class="btn btn-outline-primary w-100 py-2 rounded-3" for="lumPeriodWithTimes">
                <i class="fas fa-clock me-2"></i>
                <span class="">{{ 'lumPeriodWithTimes' | translate }}</span>
              </label>
            </div>
          </div>

          <div class="d-flex flex-column gap-2 mt-3" *ngIf="draft.scheduleMode === 'timed'">
            <div>
              <label class="form-label small mb-1" for="lumPeriodStartTime">{{ 'holidayStart' | translate }}</label>
              <input type="time" class="form-control" id="lumPeriodStartTime" name="lumPeriodStartTime" [(ngModel)]="draft.startTimeStr">
            </div>
            <div>
              <label class="form-label small mb-1" for="lumPeriodEndTime">{{ 'holidayEnd' | translate }}</label>
              <input type="time" class="form-control" id="lumPeriodEndTime" name="lumPeriodEndTime" [(ngModel)]="draft.endTimeStr">
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <div class="col-12 col-xl-10">
      <div class="border rounded-3 p-2 bg-white shadow-sm h-100">
        <div class="annual-datepicker annual-datepicker--year-grid" [ngStyle]="periodColorStyles()">
          <ng-template #dayTemplate let-date>
            <span [ngClass]="getDayClasses(date)">{{ date.day }}</span>
          </ng-template>

          <ngb-datepicker
            [startDate]="{ year: year, month: 1 }"
            [displayMonths]="12"
            [navigation]="'none'"
            [outsideDays]="'hidden'"
            [dayTemplate]="dayTemplate"
            (dateSelect)="onCalendarSelect($event)">
          </ngb-datepicker>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer border-0 pt-0">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
    {{ 'cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="!canSave" (click)="save()">
    {{ draft.id ? ('save' | translate) : ('lumPeriodCreateButton' | translate) }}
  </button>
</div>
